import script from "./ImageDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageDetails.vue?vue&type=script&setup=true&lang=js"

import "./ImageDetails.vue?vue&type=style&index=0&id=fb599826&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb599826"]])

export default __exports__